import { Basic } from "../../basic.ts";

const dependencies = ['drop-position', 'border', 'placeholder']

const template = () => `
    <style>
        :host {
            position: static !important;
            z-index: 1000;
            right: 5%;
            top: 25px;
            border: none !important;
            overflow: visible !important;
        }

        li {
            list-style: none;
        }

        ul {
            padding: 0;
            margin: 0;
        }

        .dropdown-wrap {
            position: relative;
        }

        .dropdown-list-wrap {
            width: 100%;
            box-sizing: border-box;
            position: absolute;
            box-sizing: border-box;
            display: none;
            left: 0;
            font-size: 12px;
        }

        .dropdown-wrap.active .dropdown-list-wrap {
            display: block;
        }

        .dropdown-list {
            width: 100%;
            box-sizing: border-box;
        }

        .dropdown-wrap.active .childrens {
            display: block;
        }

        .dropdown-wrap {
            border: none;
        }

        .dropdown-value {
            font-size: 12px;
        }
    </style>
    <style id="dropdown-styles">
    </style>
    <div id="dropdown-inner" class="dropdown-wrap">
        <div class="dropdown-value" id="dropdown-value">
            <slot name="label"></slot>
        </div>
        <div id="dropdown-list-wrap" class="dropdown-list-wrap">
            <ul id="dropdown-list" class="dropdown-list"></ul>
            <div class="childrens"><slot name="childrens"></slot></div>
        </div>
    </div>
`;

export class MSDropdown extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat(dependencies);
    }
    /**
     * @constructor
     * */
    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = template();
        this.root = shadowRoot.querySelector('#dropdown-wrap')
        this.init();
    }

    init() {
        this._values = []
        this._value = ""
        this.placeholder = ''
        this._active = false
        this.canOpen = true
        this.childrens = this.shadowRoot.querySelector("#dropdown-list-wrap")
        this.cssElem = this.shadowRoot.getElementById("dropdown-styles")
        this.labelElem = this.shadowRoot.querySelector("#dropdown-value slot")
        this.rootElem = this.shadowRoot.getElementById("dropdown-inner")
        this.rootElem.addEventListener('click', this.toggleHandler.bind(this))
        this.listElem = this.shadowRoot.getElementById("dropdown-list")
        this.listElem.addEventListener('click', this.onChangeHandler.bind(this))
        this.dropPosition = 'bottom'
        this.border = 0
    }

    toggleHandler(e) {
        if(this.canOpen){
            this.active = !this.active
        }
    }

    createList() {
        this.listElem.innerHTML = ''
        if (!this.values.length) return
        for (let i = 0; i < this.values.length; i++) {
            const { component, id, active, value } = this.values[i]
            if (!active) continue
            const elem = document.createElement('li')
            elem.setAttribute('Id', id)
            elem.setAttribute('Value', value)
            if (typeof component === 'string') elem.innerHTML = component
            else elem.appendChild(component)
            this.listElem.appendChild(elem)
        }
    }

    onChangeHandler(e) {
        this.onClick?.(e)
    }

    calculateOffset() {
        if (this.dropPosition === 'bottom') {
            this.childrens.style.top = `calc(100% - ${this.border}px)`
            this.childrens.style.bottom = `auto`
        }
        else {
            this.childrens.style.bottom = `calc(100% + ${this.border}px)`
            this.childrens.style.top = `auto`
        }
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        if (attrName === 'border') this.border = newVal
        if (attrName === 'drop-position') this.dropPosition = newVal
        if (attrName === 'placeholder') this.placeholder = newVal
    }

    disconnectedCallback() {
        this.listElem.removeEventListener('click', this.onChangeHandler.bind(this))
        this.rootElem.removeEventListener('click', this.toggleHandler.bind(this))

        this._values = null
        this._value = ""
        this.placeholder = ''
        this._active = false
        this.canOpen = true
        this.childrens = null
        this.cssElem = null
        this.labelElem = null
        this.rootElem = null
        this.listElem = null
        super.disconnectedCallback();
    }

    get values() {
        return this._values
    }
    set values(v) {
        this._values = v
    }

    get active() {
        return this._active
    }
    set active(v) {
        this._active = v;
        if (this._active) this.rootElem?.classList.add('active')
        else this.rootElem?.classList.remove('active')
        this.onActive?.(v)
    }

    get dropPosition() {
        return this._dropPosition
    }
    set dropPosition(v) {
        this._dropPosition = v;
        this.calculateOffset()
    }

    get border() {
        return this._border
    }
    set border(v) {
        this._border = +v
        this.calculateOffset()

    }

    get placeholder() {
        return this._placeholder
    }
    set placeholder(v) {
        this._placeholder = v
        if (this.labelElem && !this.labelElem.innerHTML.length) {
            this.labelElem.innerHTML = v
        }
    }
}